export default __webpack_public_path__ + "static/media/privacy-policy-kr-1.ff58a997.jpg";